import * as R from 'remeda';
import { z } from 'zod';

export const calendlyLinks = {
  dc: 'https://calendly.com/d/crwy-9k2-cd2/rossum-product-discovery',
  pat: 'https://calendly.com/d/cnzh-t22-y75/rossum-product-feedback-discovery-call',
  integration: 'https://calendly.com/d/cn3p-yhy-4z3/rossum-product-discovery',
} as const satisfies Record<CalendlyLinkVariantSchema, string>;

export const calendlyLinkVariants = R.keys(calendlyLinks);

export const calendlyLinkVariantSchema = z.union([
  z.literal('dc'),
  z.literal('pat'),
  z.literal('integration'),
]);

type CalendlyLinkVariantSchema = z.infer<typeof calendlyLinkVariantSchema>;
